import { Grid, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { FilterProps } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginRight: theme.spacing(2)
  },
  bottomItem: {
    marginTop: theme.spacing(2)
  }
}))

const NumericFilter = (props: FilterProps<'numeric'>) => {
  const { state = {}, setState, validate, setValid, setValidate, helperText } = props;
  const classes = useStyles();
  const [toString, setToString] = React.useState<string>(state.to && state.to.toString() || undefined);
  const [fromString, setFromString] = React.useState<string>(state.from && state.from.toString() || undefined);

  React.useEffect(() => {
    if (validate) {
      // if error on either input
      if ((state.from !== undefined && isNaN(state.from)) || (state.to !== undefined && isNaN(state.to))) {
        setValidate(false);
      } else {
        setValid(true);
        setState({ to: toString ? parseFloat(toString) : undefined, from: fromString ? parseFloat(fromString) : undefined })
      }
    }
  }, [validate])

  return <Grid
    container
    direction='column'
  >
    <Grid
      alignItems='center'
      container
      item
    >
      <Typography className={classes.text}>At least</Typography>
      <TextField
        error={state.from !== undefined && isNaN(state.from)}
        helperText={state.from !== undefined && isNaN(state.from) && 'Input must be a number' || helperText || ''}
        onChange={(e) => setFromString(e.target.value)}
        size='small'
        value={fromString}
        variant='outlined'
      />
    </Grid>
    <Grid
      alignItems='center'
      className={classes.bottomItem}
      container
      item
    >
      <Typography className={classes.text}>At most</Typography>
      <TextField
        error={state.to !== undefined && isNaN(state.to)}
        helperText={state.to !== undefined && isNaN(state.to) && 'Input must be a number' || ''}
        onChange={(e) => setToString(e.target.value)}
        size='small'
        value={toString}
        variant='outlined'
      />
    </Grid>
  </Grid>;
};

export default NumericFilter;